import { render, staticRenderFns } from "./UserRoleUpdate.vue?vue&type=template&id=b1b50ade&scoped=true&"
import script from "./UserRoleUpdate.vue?vue&type=script&lang=js&"
export * from "./UserRoleUpdate.vue?vue&type=script&lang=js&"
import style1 from "./UserRoleUpdate.vue?vue&type=style&index=1&id=b1b50ade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b50ade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1b50ade')) {
      api.createRecord('b1b50ade', component.options)
    } else {
      api.reload('b1b50ade', component.options)
    }
    module.hot.accept("./UserRoleUpdate.vue?vue&type=template&id=b1b50ade&scoped=true&", function () {
      api.rerender('b1b50ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Administrator/components/User/UserRoleUpdate.vue"
export default component.exports